import { Col } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setAudioCall, setVideoCall } from "../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../Utils";
import SharedDocument from "./SharedDocument";

const UserCallProfile = () => {
  const dispatch = useAppDispatch();
  const { activeCallUser } = useAppSelector((state) => state.chat);

  return (
    <Col sm="5">
      <div className="user-profile mb-3">
        <div className="user-content">
          <Image className="img-fluid" src={dynamicImage(`contact/${activeCallUser ? activeCallUser?.userImage : "1"}.jpg`)} alt="user-img" />
          <h3>{activeCallUser ? activeCallUser?.userName : "Jony Lynetin"}</h3>
          <h4 className="mt-2">+0 1800 76855</h4>
          <ul>
            <li><i className="fa fa-twitch" />massage</li>
            <li><i className="fa fa-phone" onClick={() => dispatch(setAudioCall())} />voice call</li>
            <li><i className="fa fa-video-camera" onClick={() => dispatch(setVideoCall())} />video call</li>
          </ul>
        </div>
      </div>
      <div className="user-profile">
        <SharedDocument />
      </div>
    </Col>
  );
};

export default UserCallProfile;
